import styled from 'styled-components';
import { s } from './CourtInformation.styles';
import { useEffect, useState } from 'react';
import { BasicInfo } from './data';
import LoanInfoService from '../../../service/LoanInfo';
import Loading from '../../../func/components/loading/LoadingCircle';
import { DetailNoDataColumn } from '../../components/nodata/NoData';
import Footer from '../../components/footer/Footer';
import { useNavigate } from 'react-router-dom';
const exportIcon = '/assets/images/icon/Icon_Export_gray.svg'
const arrowIcon = '/assets/images/icon/Arrow.svg'
const ItemDetailPage = () => {
  const [basicInfo, setBasicInfo] = useState<BasicInfo>();
  const [dateHistory, setDateHistory] = useState<string[][]>([['', '', '', '', '']]);
  const [listHistory, setListHistory] = useState<string[][]>([['', '', '']]);
  const [aTableData, setATableData] = useState<string[]>([]);
  const [parsedData, setParsedData] = useState<Record<string, string>>({});
  const [loading, setLoading] = useState(false);
  const params = new URLSearchParams(window.location.search);
  const iidx = params.get('iidx');
const [hasDetail, setHasDetail] = useState<boolean>(false);

  const navigate = useNavigate();
  const parseATableData = (data: string[] | null | undefined): Record<string, string> => {
    if (!Array.isArray(data)) return {};

    const parser = new DOMParser();
    const result: Record<string, string> = {};

    data.forEach((htmlString) => {
      const doc = parser.parseFromString(htmlString, 'text/html');
      const strong = doc.querySelector('strong');
      const fullText = doc.body.textContent?.trim() || '';

      if (strong) {
        const title = strong.textContent?.trim();
        const content = fullText.replace(title || '', '').replace(':', '').trim();
        if (title) result[title] = content;
      }
    });

    return result;
  };

  const getData = async (iidx: number) => {
  try {
    setLoading(true);
    const res = await LoanInfoService.courtDetail(iidx);

    const item = res.data.item_detail;

    // 데이터 존재 여부 판단
    const hasDetail = !!(item && item.basic_info);

    setBasicInfo(item.basic_info);
    setDateHistory(item.date_history || [['', '', '', '', '']]);
    setListHistory(item.list_history || [['', '', '']]);

    let tableData: string[] = [];
    try {
      tableData = JSON.parse(item.a_table || '[]');
    } catch (e) {
      console.error('Failed to parse a_table:', e);
    }
    setATableData(tableData);

    const parsed = parseATableData(tableData);
    setParsedData(parsed);

    // hasDetail 상태도 같이 저장할 수 있게 상태 추가 필요 (예: setHasDetail)
    setHasDetail(hasDetail);

    setLoading(false);
  } catch (e) {
    console.error(e);
    setLoading(false);
  }
};

  useEffect(() => {
    const idx = Number(iidx);
    console.log(basicInfo);
    if (iidx && !isNaN(idx)) {
      getData(idx);
    }
  }, [iidx]);

    useEffect(() => {
  window.scrollTo(0, 0);
}, [iidx]);

  if (loading) return <div>Loading...</div>;
  if (!basicInfo) return <div>데이터를 불러올 수 없습니다.</div>;

  return (
    <s.Container>
      {loading && <Loading />}
      {!loading && (
        <s.Inner>
          <TitleWrapper>
            <PageTitleBox>
              <div style={{display:'flex', alignItems: 'center', gap:'6px', letterSpacing:'-0.36px'}}>
                <BackButton onClick={() => window.close()}>
                  <img src={arrowIcon} alt="" />
                </BackButton>
                <div style={{ color: '#222222' }} >{basicInfo?.case_no} 물건상세</div>
              </div>
              <IconWrapper>
                <img src={exportIcon} alt="" style={{ width: '24px', height: '24px' }}/>
              </IconWrapper>
              </PageTitleBox>
          </TitleWrapper>
        <InnerItem style={{ padding: '0 16px 32px' }}>
          {/* 물건기본정보 */}
          <s.Content>
            <s.ContentTitleBox style={{ fontWeight: '500' }}>물건기본정보</s.ContentTitleBox>
            <s.Table style={{ marginBottom: '24px' }}>
              <tbody>
                <s.Row>
                  <s.TitleCell width="100px">사건번호</s.TitleCell>
                  <s.ContentCell width="auto">
                    {basicInfo?.case_no}
                  </s.ContentCell>
                </s.Row>
                <s.Row>
                    <s.TitleCell width="100px">물건번호</s.TitleCell>
                    <s.ContentCell width="auto">
                      {basicInfo?.unit_no}
                    </s.ContentCell>
                </s.Row>
                <s.Row>
                  <s.TitleCell width="100px">물건종류</s.TitleCell>
                  <s.ContentCell width="auto">
                    {basicInfo?.item_category}
                  </s.ContentCell>
                </s.Row>
                <s.Row>
                  <s.TitleCell width="100px">감정평가액</s.TitleCell>
                  <s.ContentCell width="auto">
                    {basicInfo?.appraised_price}
                  </s.ContentCell>
                  </s.Row>
                <s.Row>
                  <s.TitleCell width="100px">최저매각가격</s.TitleCell>
                  <s.ContentCell width="auto">
                    {basicInfo?.min_price}
                </s.ContentCell>
                </s.Row>
                <s.Row>
                  <s.TitleCell width="100px">입찰방법</s.TitleCell>
                  <s.ContentCell width="auto">
                    {basicInfo?.bid_process}
                  </s.ContentCell>
                </s.Row>
                <s.Row>
                  <s.TitleCell width="100px">매각기일</s.TitleCell>
                  <s.ContentCell width="auto" colSpan={5}>
                    {basicInfo?.sale_date}
                  </s.ContentCell>
                </s.Row>
                <s.Row>
                  <s.TitleCell width="100px">목록1 소재지</s.TitleCell>
                  <s.ContentCell width="auto" colSpan={5}>
                    {basicInfo?.list_addr?.[0] ?? '주소 정보가 없습니다'}
                  </s.ContentCell>
                </s.Row>
                <s.Row>
                  <s.TitleCell width="100px">담당</s.TitleCell>
                  <s.ContentCell width="auto" colSpan={5}>
                    {basicInfo?.manager}
                  </s.ContentCell>
                </s.Row>
              </tbody>
            </s.Table>
            <s.Table>
              <tbody>
                <s.Row>
                  <s.TitleCell width="100px">사건접수</s.TitleCell>
                  <s.ContentCell width="auto">
                    {basicInfo?.regist_date}
                  </s.ContentCell>
                </s.Row>
                <s.Row>
                    <s.TitleCell width="100px">경매개시일</s.TitleCell>
                    <s.ContentCell width="auto">
                      {basicInfo?.start_date}
                    </s.ContentCell>
                </s.Row>
                <s.Row>
                  <s.TitleCell width="100px">배당요구종기</s.TitleCell>
                  <s.ContentCell width="auto">
                    {basicInfo?.div_date}
                  </s.ContentCell>
                </s.Row>
                  <s.Row>
                  <s.TitleCell width="100px">청구금액</s.TitleCell>
                  <s.ContentCell width="auto">
                    {basicInfo?.billing_price}
                  </s.ContentCell>
                </s.Row>
              </tbody>
            </s.Table>
          </s.Content>
          {/* 기일내역 */}
          <s.Content>
            <s.ContentTitleBox style={{ fontWeight: '500' }}>기일내역</s.ContentTitleBox>
              <TableScrollWrapper style={{ width: '100%' }}>
                <s.Table style={{ minWidth: '533px', width: 'fit-content' }}>
                <thead>
                  <s.Row>
                    <s.TableHeadTh width="140px">기일 / 기일종류</s.TableHeadTh>
                    <s.TableHeadTh width="140px">최저매각가격</s.TableHeadTh>
                    <s.TableHeadTh width="110px">기일결과</s.TableHeadTh>
                    <s.TableHeadTh width="140px">기일장소</s.TableHeadTh>
                  </s.Row>
                </thead>
                <tbody>
                  {dateHistory &&
                    dateHistory.length > 0 &&
                    dateHistory.map((data, index) => (
                      <s.Row key={index}>
                        <s.ContentCell
                          width="auto"
                          textAlign="left"
                          style={{ borderRight: '1px solid #e1e2e4' }}
                        >
                          <div style={{ color: '#616161', marginBottom: '2px' }}>
                            {data[0]}
                          </div>
                          <div>
                            {data[1]}
                          </div>
                        </s.ContentCell>
                        <s.ContentCell
                          width="auto"
                          textAlign="center"
                          style={{ borderRight: '1px solid #e1e2e4' }}
                        >
                          {data[3]}
                        </s.ContentCell>
                        <s.ContentCell
                          width="auto"
                          textAlign="center"
                          style={{ borderRight: '1px solid #e1e2e4' }}
                        >
                          {data[4]}
                        </s.ContentCell>
                        <s.ContentCell
                          width="auto"
                          border={true}
                          textAlign="center"
                        >
                          {data[2]}
                        </s.ContentCell>
                      </s.Row>
                    ))}
                  {dateHistory.length === 0 && (
                    <DetailNoDataColumn absorption={5} />
                  )}
                </tbody>
                </s.Table>
               </TableScrollWrapper>
      
          </s.Content>
          {/* 목록내역 */}
          <s.Content>
            <s.ContentTitleBox style={{ fontWeight: '500' }}>목록내역</s.ContentTitleBox>
            <s.Table style={{ marginBottom: '25px' }}>
              <tbody>
                 {listHistory && listHistory.length > 0 ? (
                  listHistory.map((data, index) => (
                    <div key={index}>
                      <ItemBox>
                        <s.Label>목록번호</s.Label>
                        <s.ContentItem>{data[0]}</s.ContentItem>
                      </ItemBox>
                      <ItemBox>
                        <s.Label>목록구분</s.Label>
                        <s.ContentItem>{data[1]}</s.ContentItem>
                      </ItemBox>
                      <ItemBox>
                        <s.Label>상세내역</s.Label>
                        <s.ContentItem>{data[2]}</s.ContentItem>
                      </ItemBox>
                    </div>
                  ))
                ) : (
                  <div>데이터가 없습니다.</div>
                )}
              </tbody>
            </s.Table>
            <s.GrayBox>
              목록구분이 집합건물 혹은 건물이고 도로명주소가 부여된 목록의 경우
              상세내역 주소표기는 지번주소와 도로명주소 병기표기를 원칙으로
              하며, 이는 부동산등기기록의 표기형식을 준용한 것입니다.
            </s.GrayBox>
          </s.Content>
           {/* 감정평가요향표 요약 */}
            {aTableData && aTableData.length > 0 && (
              <s.Content>
                <s.ContentTitleBox>감정평가요향표 요약</s.ContentTitleBox>
                <AppraisalEssentialsTable>
                   <ContentTitle>구분건물감정평가요항표</ContentTitle>
                  {aTableData &&
                    aTableData.map((data, index) => (
                      <BlockTitle
                        key={index}
                        dangerouslySetInnerHTML={{ __html: data }}
                      ></BlockTitle>
                    ))}
                </AppraisalEssentialsTable>
              </s.Content>
            )}
            </InnerItem>
        </s.Inner>
      )}
      <Footer/>
    </s.Container>
  );
  
};
export default ItemDetailPage;

const ContentTitle = styled.div`
  font-family: Spoqa Han Sans Neo;
  font-size: 16px;
  font-weight: 700;
  color: #222;
  margin-bottom: 16px;
`

const AppraisalEssentialsTable = styled.div`
  width: 100%;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  border-radius: 8px;
  border: 1px solid #e8e9ea;
  margin-bottom: 8px;
`;

const BlockTitle = styled.div`
  font-family: Spoqa Han Sans Neo;
  font-size: 13px;
  font-weight: 500;
  color: #616161;
  margin-bottom: 16px;
`;

const TableScrollWrapper = styled.div`
  overflow-x: auto;
  padding-bottom: 24px; 
  width: 100%;

  &::-webkit-scrollbar {
    height: 8px;
    background-color: #000;
  }

  &::-webkit-scrollbar-track {
     
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: #999;
  }

  &::-webkit-scrollbar-button {
    display: none;
    height: 0;
    width: 0;
  }
  scrollbar-color: #C1C1C1 #F0F0F0; /* Firefox */
  scrollbar-width: thin;
`;

const InnerItem = styled.div`
 padding: 0 16px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

const TitleWrapper = styled.div`
  width: 100%;
  border-bottom: 1px solid #70737C29;
`

const PageTitleBox = styled.div`
  width: 100%;
  font-size: 18px;
  font-weight: 700;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 16px;
  ;
`

const BackButton = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

const IconWrapper  = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

const ItemBox = styled.div`
  display: flex;
  border-bottom: 1px solid #E1E2E4;
`;